import "./App.css";
import Layouts from "./components/Layouts";

function App() {
  return <Layouts />;
}

export default App;
